import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { slugLookup } from "../services/slugLookupService";

export const fetchSlugLookupAsync = createAsyncThunk(
  "slugLookup/fetch",
  async ({ q, type = "both" }, { rejectWithValue }) => {
    try {
      return await slugLookup({ q, type }); // ✅ no token arg
    } catch (error) {
      return rejectWithValue(error?.message || "Slug lookup failed");
    }
  }
);

const initialState = {
  citySuggestions: [],
  nicheSuggestions: [],
  loadingCity: false,
  loadingNiche: false,
  errorCity: null,
  errorNiche: null,

  lastCityRequestId: null,
  lastNicheRequestId: null,
};

const slugLookupSlice = createSlice({
  name: "slugLookup",
  initialState,
  reducers: {
    clearCitySuggestions: (state) => {
      state.citySuggestions = [];
      state.loadingCity = false;
      state.errorCity = null;
      state.lastCityRequestId = null;
    },
    clearNicheSuggestions: (state) => {
      state.nicheSuggestions = [];
      state.loadingNiche = false;
      state.errorNiche = null;
      state.lastNicheRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSlugLookupAsync.pending, (state, action) => {
        const t = (action.meta.arg?.type || "both").toLowerCase();

        if (t === "city") {
          state.loadingCity = true;
          state.errorCity = null;
          state.lastCityRequestId = action.meta.requestId;
        }
        if (t === "niche") {
          state.loadingNiche = true;
          state.errorNiche = null;
          state.lastNicheRequestId = action.meta.requestId;
        }
        if (t === "both") {
          state.loadingCity = true;
          state.loadingNiche = true;
          state.errorCity = null;
          state.errorNiche = null;
          state.lastCityRequestId = action.meta.requestId;
          state.lastNicheRequestId = action.meta.requestId;
        }
      })
      .addCase(fetchSlugLookupAsync.fulfilled, (state, action) => {
        const t = (action.meta.arg?.type || "both").toLowerCase();
        const payload = action.payload || {};

        if (t === "city") {
          if (state.lastCityRequestId !== action.meta.requestId) return;
          state.loadingCity = false;
          state.citySuggestions = payload.cities || [];
        }

        if (t === "niche") {
          if (state.lastNicheRequestId !== action.meta.requestId) return;
          state.loadingNiche = false;
          state.nicheSuggestions = payload.niches || [];
        }

        if (t === "both") {
          if (state.lastCityRequestId !== action.meta.requestId) return;
          if (state.lastNicheRequestId !== action.meta.requestId) return;
          state.loadingCity = false;
          state.loadingNiche = false;
          state.citySuggestions = payload.cities || [];
          state.nicheSuggestions = payload.niches || [];
        }
      })
      .addCase(fetchSlugLookupAsync.rejected, (state, action) => {
        const t = (action.meta.arg?.type || "both").toLowerCase();
        const err = action.payload || "Slug lookup failed";

        if (t === "city") {
          if (state.lastCityRequestId !== action.meta.requestId) return;
          state.loadingCity = false;
          state.citySuggestions = [];
          state.errorCity = err;
        }

        if (t === "niche") {
          if (state.lastNicheRequestId !== action.meta.requestId) return;
          state.loadingNiche = false;
          state.nicheSuggestions = [];
          state.errorNiche = err;
        }

        if (t === "both") {
          if (state.lastCityRequestId !== action.meta.requestId) return;
          if (state.lastNicheRequestId !== action.meta.requestId) return;
          state.loadingCity = false;
          state.loadingNiche = false;
          state.citySuggestions = [];
          state.nicheSuggestions = [];
          state.errorCity = err;
          state.errorNiche = err;
        }
      });
  },
});

export const { clearCitySuggestions, clearNicheSuggestions } = slugLookupSlice.actions;

export default slugLookupSlice.reducer;
